import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CalendarEvent, colorHex } from "./types";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  date: Date | null;
  events: CalendarEvent[];
  onSelect: (ev: CalendarEvent) => void;
}

export function DayEventsModal({ open, onOpenChange, date, events, onSelect }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>
            {date ? format(date, "EEEE, d 'de' MMMM", { locale: ptBR }) : "Eventos"}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-1.5 max-h-[60vh] overflow-y-auto">
          {events.length === 0 && (
            <p className="text-sm text-muted-foreground">Nenhum evento.</p>
          )}
          {events.map((ev) => (
            <button
              key={ev.id}
              onClick={() => {
                onSelect(ev);
                onOpenChange(false);
              }}
              className="w-full text-left flex items-center gap-2 px-2.5 py-2 rounded-lg hover:bg-muted transition-colors"
            >
              <span
                className="h-2.5 w-2.5 rounded-full shrink-0"
                style={{ backgroundColor: colorHex(ev.color) }}
              />
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-medium text-foreground truncate">{ev.title}</span>
                <span className="block text-xs text-muted-foreground">
                  {ev.startTime} – {ev.endTime}
                </span>
              </span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}